export const titleLinks = (translation) => {
  return [
    {
      name: `${translation.reports.CustomerBalanceDebitor}`,
      url: '/reports/customer-balance/debitor',
    },
    {
      name: `${translation.reports.CustomerBalanceCreditor}`,
      url: '/reports/customer-balance/creditor',
    },
    {
      name: `${translation.InvoiceLine.CostLines}`,
      url: '/cost/line',
    },
    {
      name: `${translation.InvoiceLine.InvoiceLines}`,
      url: '/invoices/line',
    },
    {
      name: `${translation.profile.profile}`,
      url: '/profile',
    },
    {
      name: `${translation.create.CostButton}`,
      url: '/cost/new',
    },
    {
      name: `${translation.create.InvoiceButton}`,
      url: '/invoices/new',
    },
    {
      name: `${translation.settingTab.Settings}`,
      url: '/settings',
    },
    {
      name: `${translation.reports.IncomesAndExpences}`,
      url: '/reports/incomes-expences',
    },
    {
      name: `${translation.reports.CashFlow}`,
      url: '/reports/cash-flow',
    },
    {
      name: `${translation.reports.JobNumber}`,
      url: '/reports/job-number',
    },
    {
      name: `${translation.reports.Invoices}`,
      url: '/reports/invoices',
    },
    {
      name: `${translation.taxTypes.TaxTypes}`,
      url: '/reports/tax-types',
    },
    {
      name: `${translation.saleTypes.SaleTypes}`,
      url: '/reports/sale-types',
    },
    {
      name: `${translation.reports.Measurement}`,
      url: '/reports/measurement',
    },
    {
      name: `${translation.reports.Cancelled}`,
      url: '/reports/cancelled',
    },
    {
      name: `${translation.reports.BankTransfer}`,
      url: '/reports/bank-transfer',
    },
    {
      name: `${translation.reports.Manager}`,
      url: '/reports/manager',
    },
    {
      name: `${translation.sideMenu.Dashboard}`,
      url: '/dashboard',
    },
    {
      name: `${translation.sideMenu.Last_Transactions}`,
      url: '/invoices/create',
    },
    {
      name: `${translation.sideMenu.Invoices_Drafts}`,
      url: '/invoices/drafts',
    },
    {
      name: `${translation.sideMenu.Invoices_Incomes}`,
      url: '/invoices/incomes',
    },
    {
      name: `${translation.sideMenu.Invoices_Expences}`,
      url: '/invoices/expenses',
    },
    {
      name: `${translation.sideMenu.Reports}`,
      url: '/reports',
    },
    {
      name: `${translation.sideMenu.Instructions}`,
      url: '/instructions',
    },
  ];
};
